import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
    fill="currentColor"
    stroke="transparent"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4.97 10.252C2.464 10.252 0.98 8.81 0.98 6.262V0.199999H2.828V5.982C2.828 7.802 3.57 8.698 4.97 8.698C6.356 8.698 7.112 7.774 7.112 5.982V0.199999H8.946V6.262C8.946 8.81 7.462 10.252 4.97 10.252Z" />
    <path d="M0 11.75H9.926V12.45H0V11.75Z" />
  </svg>
);
